import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroBackground from "@/components/marketing/HeroBackground";
import GulfNewswireSummaryPanel from "./GulfNewswireSummaryPanel";
import { useAuth } from "@/lib/AuthContext";

const STATS = [
  { value: "$475", label: "Fixed price" },
  { value: "80", label: "Media pickups" },
  { value: "5,000+", label: "Journalists reached" },
  { value: "6 countries", label: "UAE, KSA, Qatar, Kuwait, Bahrain, Oman" },
];

export default function GulfNewswireHero() {
  const { isAuthenticated } = useAuth();
  const primaryTo = isAuthenticated ? "/dashboard/new-order" : "/register";

  return (
    <section className="relative overflow-hidden pt-24 lg:pt-28 pb-16 lg:pb-20">
      <HeroBackground />
      <Container className="relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div className="animate-fade-up">
            <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">
              Gulf Newswire
            </div>
            <h1 className="font-heading text-[clamp(36px,5vw,56px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-5 max-w-3xl text-heading-gradient">
              Gulf newswire distribution for $475.
            </h1>
            <p className="text-[16px] lg:text-[17px] leading-[1.55] text-[#6c6c74] max-w-prose mb-8">
              One release, 80 media pickups across the Gulf, 40 in English and 40 in Arabic. Same-day submission, guaranteed placement on key regional sites, and full coverage reporting, all self serve with the price shown upfront.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-12">
              <Link to={primaryTo}
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
                Get Started <ArrowRight className="inline w-4 h-4 ml-1" />
              </Link>
              <Link to="/contact"
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-dark-pill text-white whitespace-nowrap transition-colors hover:bg-[#3c3c42]">
                Talk to Our Team
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 pt-8 border-t border-[rgba(28,28,32,0.06)]">
              {STATS.map((stat) => (
                <div key={stat.label}>
                  <div className="font-mono text-2xl lg:text-3xl font-bold text-[#7c3aed]">{stat.value}</div>
                  <div className="font-mono text-xs uppercase tracking-widest text-[#8e8e96] mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="animate-fade-up lg:self-center" style={{ animationDelay: "0.3s", animationFillMode: "both" }}>
            <GulfNewswireSummaryPanel />
          </div>
        </div>
      </Container>
    </section>
  );
}